import {map} from 'lodash';
import * as React from 'react';
import {Pages} from '../../../pages';
import {navigateTo} from '../../../router';
import {Container} from '../../grid/container';
import './style.scss';
import {Translation} from "../../../lang";

const iaomSvg: string = '/assets/src/components/libs/navigation/iaom-white.svg';

const navigationItems: any = map(Pages);

export class NavigationComponent extends React.Component<any, any> {
    public navigationStatus$ = (window as any).siteEventSubscribers.navigation.status;
    public windowResize$ = (window as any).siteEventSubscribers.window.resize;
    public containerOnScroll$ = (window as any).siteEventSubscribers.contentScroll;
    public ref: HTMLElement;

    componentDidMount(): void {
        this.navigationStatus$.subscribe(async (s: boolean) => {
            this.setState({
                status: s
            });
        });

        this.windowResize$.subscribe(() => this.navigationStatus$.next(false));
        this.containerOnScroll$.subscribe((scrollTop: any) => {
            this.setState({
                colored: (scrollTop > 0)
            });
        });
    }

    public state: any = {
        status: false,
        preventButton: false,
        colored: false
    };

    public onItemClick(item: any) {
        navigateTo(item.path);
        this.navigationStatus$.next(false);
    }

    render() {
        return <div
            className={`navigationComponent ${this.state.status ? 'opened' : ''} ${(!this.state.status && this.state.colored) ? 'colored' : ''}`}
            ref={(ref: any) => {
                this.ref = ref;
            }}>

            <img src={iaomSvg} className="iaomLogo" onClick={() => navigateTo('/')}/>
            <div className={'lang-selector'}>
                {Translation.getLang() === 'hu' &&
                    <span className="MS" onClick={() => Translation.setLang('en')}>EN</span>}
                {Translation.getLang() === 'en' &&
                    <span className="MS" onClick={() => Translation.setLang('hu')}>HU</span>}
            </div>
            <div className="hamburger opener"
                 onClick={() => !this.state.preventButton ? this.navigationStatus$.next(!this.state.status) : null}>
                <span className="menu-dot dot-1"/>
                <span className="menu-dot dot-2"/>
                <span className="menu-dot dot-3"/>
            </div>

            <div className={`navigationWrapper animated ${this.state.status ? 'fadeInRight' : 'fadeOutRight'}`}>
                <Container disableScrollEvent={true}>

                    <div className="navItemsWrapper">

                        {navigationItems.map((item: any, index: number) => <div
                            className="navItem relative" key={index}
                            onClick={() => this.onItemClick(item)}>

                            <div className="underL" style={{
                                backgroundImage: `linear-gradient(90deg, ${item.colorMatrix[0]}, ${item.colorMatrix[1]})`
                            }}/>

                            <h2 className={`pointer MS text-white fw-bold fst-italic animated animate-delay-ms-${30 * index} ${this.state.status ? 'fadeInRight' : 'fadeOutRight'}`}>
                                {item.title}
                            </h2>

                        </div>)}

                    </div>

                </Container>
            </div>

        </div>;
    }
}
